export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * Genera la URL de login de Keycloak
 * La URL debe apuntar al endpoint de autorización de Keycloak
 */
export const getLoginUrl = () => {
  // VITE_OAUTH_PORTAL_URL debe ser algo como:
  // http://localhost:8080/realms/ava/protocol/openid-connect
  const metaEnv = (import.meta as unknown as { env: Record<string, string | undefined> }).env;
  const keycloakBaseUrl = metaEnv.VITE_OAUTH_PORTAL_URL;
  const clientId = metaEnv.VITE_APP_ID || "ava-app";
  
  if (!keycloakBaseUrl || keycloakBaseUrl === '') {
    console.warn('[Auth] VITE_OAUTH_PORTAL_URL no configurado');
    return '/login';
  }
  
  try {
    const redirectUri = `${window.location.origin}/api/oauth/callback`;
    const state = btoa(redirectUri);
    
    // Construir URL de autorización
    // Si keycloakBaseUrl termina en /protocol/openid-connect, agregar /auth
    let authUrl = keycloakBaseUrl;
    if (authUrl.endsWith('/protocol/openid-connect')) {
      authUrl = authUrl + '/auth';
    } else if (!authUrl.includes('/auth')) {
      authUrl = authUrl + '/auth';
    }
    
    const url = new URL(authUrl);
    url.searchParams.set("client_id", clientId);
    url.searchParams.set("redirect_uri", redirectUri);
    url.searchParams.set("state", state);
    url.searchParams.set("response_type", "code");
    url.searchParams.set("scope", "openid profile email");

    // URL generada (no loguear en produccion por seguridad)
    return url.toString();
  } catch (err: unknown) {
    // Error construyendo URL de login
    return '/login';
  }
};
